import { render, staticRenderFns } from "./KoreksiAbsen.vue?vue&type=template&id=23c1068b&scoped=true"
import script from "./KoreksiAbsen.vue?vue&type=script&lang=js"
export * from "./KoreksiAbsen.vue?vue&type=script&lang=js"
import style0 from "./KoreksiAbsen.vue?vue&type=style&index=0&id=23c1068b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23c1068b",
  null
  
)

export default component.exports